import React, { useContext } from "react";
import useStyles from "./styles";
import { FormControl, InputBase, MenuItem, Select } from "@material-ui/core";
import useCountriesList from "../../hooks/useCountriesList";
import { PaymentInfoContext } from "../../App";
import { useTranslation } from 'react-i18next';

const CountrySelect = ({ formik }) => {
  const paymentInfo = useContext(PaymentInfoContext);
  const classes = useStyles();
  const countriesList = useCountriesList();
  const {t} = useTranslation();
  return countriesList && paymentInfo?.showCountryDropdown ? (
    <div className={classes.countryWrapper}>
      <FormControl className={`${classes.formControl} country_text`}>
        <Select className={'country_text'}
          input={<InputBase fullWidth />}
          fullWidth
          name="country"
          value={formik.values.country}
          onChange={formik.handleChange}>
          {countriesList?.map((country, index) => (
            <MenuItem key={`${country?.iso}-${index}`} value={country?.iso} className={"country_text"}>
              <img alt="" src={require(`../../assets/flag_icons/png/${country?.iso}.png`).default} className={classes.countryImage}/>
              <span className="country_text">{t(country.iso)}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  ) : null
}

export default CountrySelect
